import { useEffect, useState, type ReactElement } from 'react';
import { subscribeToToasts, type Toast } from '@/lib/toast-bus';

const DEFAULT_LIFETIME_MS = 5000;

export function Toaster(): ReactElement {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const unsubscribe = subscribeToToasts((toast) => {
      setToasts((current) => [...current, toast]);
      window.setTimeout(() => {
        setToasts((current) => current.filter((t) => t.id !== toast.id));
      }, DEFAULT_LIFETIME_MS);
    });
    return unsubscribe;
  }, []);

  if (toasts.length === 0) return <></>;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 pointer-events-none"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="pointer-events-auto rounded-[var(--r-md)] bg-[var(--ink-1)] text-[var(--bg)] px-4 py-2 shadow-lg text-sm"
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
}
